import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink
} from "react-router-dom";
import Retail from "./Retail";
import logo from "./img/Extreme-Elements_RGB.svg";
import health from "./img/icon-healthcare.svg";
import retail from "./img/icon-retail.svg";
import education from "./img/icon-highered.svg";
import ktwelve from "./img/ktwelve.svg";

import "./css/Navigation.scss";
import "./css/animate.css";

class Navigation extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="Navigation animated bounceInDown">
        <div className="navCol navLeft">
          <Link to="/table">
            <img src={logo} className="logo" />
          </Link>
        </div>
        <div className="navCol navRight">
          <NavLink to="/healthcare" activeClassName="is-active">
            <img src={health} />
            <span className="navText">Healthcare</span>
          </NavLink>
          <NavLink to="/retail" activeClassName="is-active">
            <img src={retail} />
            <span className="navText">Retail</span>
          </NavLink>
          <NavLink to="/k12" activeClassName="is-active">
            <img src={ktwelve} />
            <span className="navText">K-12</span>
          </NavLink>
          <NavLink to="/highereducation" activeClassName="is-active">
            <img src={education} />
            <span className="navText">Higher Ed</span>
          </NavLink>
        </div>
      </div>
    );
  }
}

export default Navigation;
